import React from 'react';
import './ResetRotation.css';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import NorthArrow from '../../_assets/img/north1.png';

function ResetRotation({ map }) {
  const { t } = useTranslation();

  const handleResetRotation = () => {
    if (map) {
      map.getView().setRotation(0);
    }
  };

  return (
    <div className="ResetRotation">
      <Button
        className="ResetRotationButton"
        onClick={handleResetRotation}
        title={t('resetRotation.tooltip')}
        aria-label={t('resetRotation.tooltip')}
        text
      >
        <img
          src={NorthArrow}
          alt={t('resetRotation.tooltip')}
          className="ResetRotationIcon"
        />
      </Button>
    </div>
  );
}

export default ResetRotation;
